// hide or show button according scrollbar position
import { addClass, getWindowsHeight, removeClass } from '../helpers/generic';

export const back2Top = (): void => {
    const documentHeight = getWindowsHeight();
    const windowHeight = window.innerHeight;
    const scrollPosition = window.pageYOffset;
    //const link = $("a.back-2-top");
    const collection: HTMLCollectionOf<Element> = document.getElementsByClassName('back-2-top');
    const link = collection[0];

    if (link) {
        if (scrollPosition < windowHeight) {
            // je treba odscrollovat minimalne pres vysku celeho okna
            addClass(link, 'back-2-top--not-used');
        } else {
            removeClass(link, 'back-2-top--not-used');
            if (scrollPosition + windowHeight >= documentHeight) {
                // je odscrollovano zcela dolu
                addClass(link, 'back-2-top--end-position');
            } else {
                removeClass(link, 'back-2-top--end-position');
            }
        }
    }
};
